var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chart-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex align-items-center mb-2" }, [
      _c("label", { staticClass: "mb-0 mr-2" }, [_vm._v("Desde")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localFrom,
            expression: "localFrom",
          },
        ],
        staticClass: "form-control form-control-sm mr-2",
        attrs: { type: "date" },
        domProps: { value: _vm.localFrom },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.localFrom = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "mb-0 mr-2" }, [_vm._v("Hasta")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localTo,
            expression: "localTo",
          },
        ],
        staticClass: "form-control form-control-sm mr-2",
        attrs: { type: "date" },
        domProps: { value: _vm.localTo },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.localTo = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-sm mr-2",
          on: { click: _vm.applyLocalFilter },
        },
        [_vm._v("\n            Aplicar\n        ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-secondary btn-sm",
          attrs: {
            disabled: !_vm.useLocalFilter && !_vm.localFrom && !_vm.localTo,
          },
          on: { click: _vm.clearLocalFilter },
        },
        [_vm._v("\n            Limpiar\n        ")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "table-responsive" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("table", { staticClass: "table table-hover mb-4" }, [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.summaryRows, function (row) {
              return _c("tr", { key: row.id_usuario }, [
                _c("td", [_vm._v(_vm._s(row.nombre))]),
                _vm._v(" "),
                _c("td", [
                  _c("span", { staticClass: "badge badge-info" }, [
                    _vm._v(_vm._s(row.sessions_count)),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("span", { staticClass: "time-badge" }, [
                    _vm._v(_vm._s(_vm.formatSeconds(row.total_seconds))),
                  ]),
                ]),
              ])
            }),
            _vm._v(" "),
            !_vm.loading && _vm.summaryRows.length === 0
              ? _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "text-center text-muted",
                      attrs: { colspan: "3" },
                    },
                    [
                      _vm._v(
                        "\n                        Sin datos\n                    "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("table", { staticClass: "table table-hover" }, [
        _vm._m(4),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.rows, function (row) {
              return _c("tr", { key: row.id }, [
                _c("td", [_vm._v(_vm._s(row.nombre))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(row.login_time || "-"))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(row.logout_time || "-"))]),
                _vm._v(" "),
                _c("td", [
                  _c("span", { class: _vm.statusClass(row.status) }, [
                    _vm._v(_vm._s(_vm.displayStatus(row.status))),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [_c("code", [_vm._v(_vm._s(row.ip_address || "-"))])]),
              ])
            }),
            _vm._v(" "),
            !_vm.loading && _vm.rows.length === 0
              ? _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "text-center text-muted",
                      attrs: { colspan: "5" },
                    },
                    [
                      _vm._v(
                        "\n                        Sin datos\n                    "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "text-center py-3" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
          _vm._v(" Cargando...\n    "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center mb-2" },
      [
        _c("h5", [
          _c("i", { staticClass: "fal fa-link text-primary" }),
          _vm._v(" Conexiones de Agentes\n        "),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", { staticClass: "mb-2" }, [
      _c("i", { staticClass: "fal fa-list-alt text-info" }),
      _vm._v(" Resumen\n        "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Agente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Sesiones")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total Conectado")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", { staticClass: "mb-2" }, [
      _c("i", { staticClass: "fal fa-stream text-primary" }),
      _vm._v(" Detalle\n        "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Agente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Login")]),
        _vm._v(" "),
        _c("th", [_vm._v("Logout")]),
        _vm._v(" "),
        _c("th", [_vm._v("Estado")]),
        _vm._v(" "),
        _c("th", [_vm._v("IP")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }